import { api } from '@/fsd/shared/api';

interface IResult {
  access: string;
  refresh: string;
}

export const authRefresh = async (refresh: string) => {
  const response = await api.post<{ data: IResult }>('/api/v1/auth/refresh/', {
    body: { refresh },
  });

  return response.data;
};
